export function getNumber(
    no: string | number | null | undefined,
    defaultNo: number
): number {
    if (String(no) === "0") return 0;
    return Number(no) || defaultNo;
}
